module.exports = __webpack_public_path__ + "static/media/sf-onemarket-floors.72330fe7.sketch";